import { MenuItem } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import type { ProjectListNavbarStore } from "../store";

type ExportEffectivenessButtonProps = {
  store: ProjectListNavbarStore;
};

export const ExportProjectsEffectivenessButton = observer(
  function ExportEffectivenessButton({
    store,
  }: ExportEffectivenessButtonProps) {
    if (store.isProjectsEffectivenessExportDisabled) {
      return null;
    }

    return (
      <MenuItem
        isDisabled={store.isExporting}
        onClick={store.exportProjectsEffectiveness}
      >
        <Trans>Project Effectiveness</Trans>
      </MenuItem>
    );
  },
);
